import { render, staticRenderFns } from "./CsuExamsPhase.vue?vue&type=template&id=8f677ac8&scoped=true&"
import script from "./CsuExamsPhase.vue?vue&type=script&lang=js&"
export * from "./CsuExamsPhase.vue?vue&type=script&lang=js&"
import style0 from "./CsuExamsPhase.vue?vue&type=style&index=0&id=8f677ac8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f677ac8",
  null
  
)

export default component.exports